import serves from "@/http";
// import * as storage from "../storage";
import * as types from "./mutations-type";
export const ActionCadastro = ({dispatch},payload)=>{
    return serves.boletinstabela.cadastra(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionLista = ({dispatch},payload)=>{
    return serves.boletinstabela.lista(payload).then(res => {
        dispatch('ActionSetLista',res)
    }).catch(err => {
        dispatch('ActionSetLista',err)
    })
}
export const ActionPesquisa = ({dispatch},payload)=>{
    return serves.boletinstabela.pesquisa(payload).then(res => {
        dispatch('ActionSetBoletins',res)
    }).catch(err => {
        dispatch('ActionSetBoletins',err)
    })
}
export const ActionDeletar = ({dispatch},payload)=>{
    return serves.boletinstabela.delete(payload).then(res => {
        console.log(res);
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionEditar = ({dispatch},payload)=>{
    return serves.boletinstabela.editar(payload).then(res => {
        dispatch('ActionSetEditar',res)
    }).catch(err => {
        dispatch('ActionSetEditar',err)
    })
}
export const ActionDuplicar = ({dispatch},payload)=>{
    return serves.boletinstabela.duplicar(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionUpdate = ({dispatch},payload)=>{
    return serves.boletinstabela.update(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionNumero = ({dispatch},payload)=>{
    return serves.boletinstabela.numero(payload).then(res => {
        dispatch('ActionSetNumero',res)
    }).catch(err => {
        dispatch('ActionSetNumero',err)
    })
}
export const ActionSetLista = ({commit},payload) =>{
    commit(types.SET_LISTA,payload)
}
export const ActionSetMsg = ({commit},payload) =>{
    commit(types.SET_MSG,payload)
}
export const ActionSetEditar = ({commit},payload) =>{
    commit(types.SET_EDITAR,payload)
}
export const ActionSetBoletins = ({commit},payload) =>{
    commit(types.SET_BOLETINS,payload)
}
export const ActionSetNumero = ({commit},payload) =>{
    commit(types.SET_NUMERO,payload)
}
